import { useEffect, useState } from 'react';
import { resolveArtURL, cachedArtURL } from '../signedURLCache';

// Resolves a project's album art URL via the CF, caching by artId
// in `signedURLCache`. Prefers any URL the project already carries
// (e.g. share-link redeem CFs bundle the art URL pre-resolved for
// anonymous viewers). Re-resolves when the project / albumArtId
// changes.
export function useAlbumArtURL(project) {
    const [url, setUrl] = useState(() => initialUrl(project));

    useEffect(() => {
        if (!project) { setUrl(null); return; }
        if (project.imageUrl) { setUrl(project.imageUrl); return; }
        if (!project.albumArtId) { setUrl(null); return; }
        const artistId = project.artistId || project.artist?.id;
        if (!artistId) { setUrl(null); return; }

        const cached = cachedArtURL(project.albumArtId);
        if (cached) { setUrl(cached); return; }

        let cancelled = false;
        resolveArtURL({ artistId, projectId: project.id, artId: project.albumArtId })
            .then((u) => { if (!cancelled) setUrl(u); })
            .catch(() => { if (!cancelled) setUrl(null); });
        return () => { cancelled = true; };
    }, [project?.id, project?.albumArtId, project?.imageUrl, project?.artistId, project?.artist?.id]);

    return url;
}

function initialUrl(project) {
    if (!project) return null;
    if (project.imageUrl) return project.imageUrl;
    if (project.albumArtId) return cachedArtURL(project.albumArtId);
    return null;
}
